import { memo } from 'react';

import { REPEAT_PASSPORTS } from 'CorePackage/MainModule/routes/routes';
import { IRepeatPassport } from 'APIPackage/KnmModule/interfaces/IRepeatPassport';
import { Section } from 'UIPackage/FormModule/components/Section';

import styles from './ErknmRepeatPassports.module.scss';

interface IErknmRepeatPassportsProps {
  repeatPassports: IRepeatPassport[] | undefined;
}

export const ErknmRepeatPassports = memo(({ repeatPassports }: IErknmRepeatPassportsProps) => {
  return (
    <Section title="Перечень повторных мероприятий" id={REPEAT_PASSPORTS}>
      {repeatPassports ? (
        <ol className={styles.List}>
          {repeatPassports.map(passport => {
            return (
              <li key={passport.erpId}>
                <a href={passport.link} target="_blank" rel="noreferrer">
                  {passport.erpId}
                </a>
              </li>
            );
          })}
        </ol>
      ) : (
        <div>Нет данных о повторных мероприятиях</div>
      )}
    </Section>
  );
});
